import {TPMEventBO} from "./TPMEventBO";
import * as _ from 'lodash'
import {PaymentMethod_OffInvoice} from "../PA.TPM.Core/TPM.Constants";
import {TPMEventSpend} from "./TPMEventBO.ITPMEventSpend";

export class TPMEventWorkflowUtils {


  //<editor-fold desc="Financial Utils">

  static EventSpend_updateTotals(bo: TPMEventBO): void {
      //
    let dPlannedSpend: number = 0
    let dApprovedSpend: number = 0
    let dActualSpend: number = 0

    let arrEventSpend: TPMEventSpend[] = <any> _.filter(bo.TPMEventSpends, (a) => a.isActive)

    _.forEach(arrEventSpend, (aSpend) => {
      let aRow = aSpend.TPMEventSpendRow
      let SpendStatus = aSpend.PrimaryWorkflowProcessor.CurrentState
      if(aRow.cif.PAYMENT_METHOD == PaymentMethod_OffInvoice){
        if(SpendStatus.StatusTypeCancelled || SpendStatus.StatusTypePendingApproval){
          // Don't include in Total
        } else {
          dPlannedSpend += _.toNumber(aRow.cif.PLANNED_SPEND)
          dApprovedSpend += _.toNumber(aRow.cif.APPROVED_SPEND)
          dActualSpend += _.toNumber(aRow.cif.ACTUAL_SPEND)
        }

      } else {
        dPlannedSpend += _.toNumber(aRow.cif.PLANNED_SPEND)
        dApprovedSpend += _.toNumber(aRow.cif.APPROVED_SPEND)
        dActualSpend += _.toNumber(aRow.cif.ACTUAL_SPEND)
      }
    })

    bo.WB_TPMEvent.cif.PLANNED_SPEND = dPlannedSpend
    bo.WB_TPMEvent.cif.APPROVED_SPEND = dApprovedSpend
    bo.WB_TPMEvent.cif.ACTUAL_SPEND = dActualSpend
  }

  static EventSpend_updateApprovedSpend(bo: TPMEventBO): void {

    let totalApprovedSpend = 0

    let arrEventSpend: TPMEventSpend[] = <any> _.filter(bo.TPMEventSpends, (a) => a.isActive)
    _.forEach(arrEventSpend, (aSpend) => {
      let aRow = aSpend.TPMEventSpendRow
      let SpendStatus = aSpend.PrimaryWorkflowProcessor.CurrentState

      if (SpendStatus.StatusTypeCancelled){
        aRow.cif.APPROVED_SPEND = 0

        _.forEach(aRow.WB_TPM_EventSpendPrdGrpRows, (aPGRow) => {
          if(!aPGRow.isActive){ return }
          aPGRow.cif.APPROVED_SPEND = 0
        })

        _.forEach(aRow.WB_TPM_EventSpendPrdRows, (aPrdRow) => {
          if(!aPrdRow.isActive){ return }
          aPrdRow.cif.APPROVED_SPEND = 0
        })
        return
      }


      if (SpendStatus.StatusTypeInitial || SpendStatus.StatusTypePendingApproval){
        return
      }

      aRow.cif.APPROVED_SPEND = aRow.cif.PLANNED_SPEND
      totalApprovedSpend += aRow.cif.APPROVED_SPEND

      _.forEach(aRow.WB_TPM_EventSpendPrdGrpRows, (aPGRow) => {
        if(!aPGRow.isActive){ return }
        aPGRow.cif.APPROVED_SPEND = aPGRow.cif.PLANNED_SPEND
      })

      _.forEach(aRow.WB_TPM_EventSpendPrdRows, (aPrdRow) => {
        if(!aPrdRow.isActive){ return }
        aPrdRow.cif.APPROVED_SPEND = aPrdRow.cif.PLANNED_SPEND
      })

    })

    bo.WB_TPMEvent.cif.APPROVED_SPEND = totalApprovedSpend

  }

  static Event_getSpendingTotalForApproval(bo: TPMEventBO): number {

    let dTotalSpend: number = 0
    let bIsPreApproval = !bo.PrimaryWorkflowProcessor.CurrentState.StatusTypeIsPostApproval

    let arrEventSpend: TPMEventSpend[] = <any> _.filter(bo.TPMEventSpends, (a) => a.isActive)

    _.forEach(arrEventSpend, (aSpend) => {
      let aRow = aSpend.TPMEventSpendRow
      let SpendNextStatus = aSpend.PrimaryWorkflowProcessor.NextState
      if(bIsPreApproval){
        dTotalSpend += aRow.cif.PLANNED_SPEND
      } else {
          // Don't include in Total if Tactic Next State is Initial or Cancel
          if(!(SpendNextStatus.StatusTypeInitial || SpendNextStatus.StatusTypeCancelled)){
            dTotalSpend += aRow.cif.PLANNED_SPEND
          }
      }
    })

    return dTotalSpend
  }

  //</editor-fold>


}
